var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7342_284055)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7342_284055)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "#3A99FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71429 8.4H0V5.6H5.71429V0H8.57143V5.6H20V8.4H8.57143V14H5.71429V8.4Z",
    fill: "#FFDA2C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7342_284055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7342_284055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default __webpack_public_path__ + "static/media/sweden.49d8f4ce7a81543a8260a640fe50bec8.svg";
export { ForwardRef as ReactComponent };